import React from 'react';
import { Loader } from 'gocclr-shared-ui/dist/elements/loader/loader';
import styled from 'styled-components';

const Splashscreen = styled(Loader)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;
interface SafeSuspenseProps {
    children: React.ReactNode;
}

export const SafeSuspense = ({ children }: SafeSuspenseProps) => (
    <React.Suspense fallback={<Splashscreen />}>
        {children}
    </React.Suspense>
);